import { Card, Col, Row } from 'antd'
import { useEffect } from 'react'

import { useDashboardFilters } from '@contexts'

import { ContentContainer } from '../../../../components/StyledComponents'
import { GlobalComplianceChart } from '../components/GlobalComplianceChart'
import {
  CarrierSelector,
  ComplianceStatusSelector,
  HeaderRow,
  MonthYearSelector,
  MonthlySupplierMetricsTable,
  SupplierSelector,
  TripTypeSelector,
  MonthlyComplianceByZoneChart,
} from '../components'

const MonthlyDashboard = () => {
  const { resetFiltersToDefaults } = useDashboardFilters()

  useEffect(() => {
    resetFiltersToDefaults()
  }, [resetFiltersToDefaults])

  return (
    <ContentContainer span={24}>
      <HeaderRow className="filters-list">
        <MonthYearSelector />
        <ComplianceStatusSelector />
        <TripTypeSelector />
        <SupplierSelector />
        <CarrierSelector />
      </HeaderRow>
      <Card size="small" style={{ margin: '0 0.5rem' }} styles={{ body: { padding: '1.5rem' } }}>
        <GlobalComplianceChart />
      </Card>
      <Row gutter={[8, 8]} style={{ marginTop: 21 }} align="stretch">
        <Col span={12} className="max-width-50" style={{ display: 'flex' }}>
          <Card
            size="small"
            style={{
              flex: 1,
              width: '100%',
              margin: '0 0.5rem',
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
            }}
            styles={{
              body: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                padding: '1.5rem',
                minHeight: 0,
              },
            }}
          >
            <MonthlySupplierMetricsTable />
          </Card>
        </Col>
        <Col span={12} className="max-width-50" style={{ display: 'flex' }}>
          <Card
            size="small"
            style={{
              flex: 1,
              width: '100%',
              margin: '0 0.5rem',
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
              maxHeight: 800,
            }}
            styles={{
              body: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                padding: '1.5rem',
                minHeight: 0,
              },
            }}
          >
            <MonthlyComplianceByZoneChart />
          </Card>
        </Col>
      </Row>
    </ContentContainer>
  )
}

export { MonthlyDashboard }
